const videos = [
  { title: "Hootie & the Blowfish - I Go Blind", src: "https://www.youtube.com/embed/2q8OPUUZGSA" },
  { title: "Nathaniel Rateliff - Howling at the Moon", src: "https://www.youtube.com/embed/E_wkQe30jdg" },
  { title: "The Georgia Satellites - Keep Your Hands to Yourself", src: "https://www.youtube.com/embed/HmMjypz0A1k" },
  { title: "Stealers Wheel - Stuck in the Middle with You", src: "https://www.youtube.com/embed/ubdYKfMnHHQ" },
  { title: "Weezer - Say It Ain't So", src: "https://www.youtube.com/embed/yPr_JDXlBbU" },
  { title: "The Eagles - Take It Easy", src: "https://www.youtube.com/embed/1dHJI3_4rJg" },
  { title: "4 Non Blondes - What's Up", src: "https://www.youtube.com/embed/TudTlb51swc" },
];

export default videos;